import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts";
import "./index.css";
import App from "./App";
import { initNativeApp } from "./utils/nativeApp";

const root = ReactDOM.createRoot(document.getElementById("react-root"));
root.render(<App />);

initNativeApp();
